<template>
  <div>
    <div class="sendLine">
      <input
        v-model="input"
        placeholder="Enter chat content"
        @focus="chatFlag = true"
        ref="input"
      />

      <div class="send middle" @click="send">send</div>
    </div>

    <div class="msgBox" :style="chatFlag ? '' : 'transform: translateY(500px);'">
      <div class="title">
        <p
          v-for="(item, index) in cheatList"
          :key="index"
          :class="index == value ? 'active' : ''"
          @click="chooseRoom(index)"
        >
          {{ item.name }}
        </p>

        <img
          :class="chatFlag ? 'trans' : 'trans trans1'"
          src="../assets/newImg/trans.png"
          @click="chatFlag = !chatFlag"
        />
      </div>
      <div class="box" :style="chatFlag ? '' : 'opacity:0'">
        <div class="box1" id="chat">
          <div v-for="(item, index) in msgList[value]" :key="index">
            <div class="msgList">
              <div class="name">{{ item.name }}:</div>
              <div class="sendMsg">{{ item.msg }}</div>
            </div>
          </div>
        </div>

        <div class="box2">
          <div class="msg1" v-for="(item, index) in playerList" :key="index">
            <p>{{ item.name }}</p>
            <img
              src="../assets/newImg/chatRoom/chat.png"
              class="logo"
              v-if="item.name != $chat.role.name"
              @click="onlyChat(item.name, item.name, item.id)"
            />

            <img src="../assets/newImg/chatRoom/chat.png" class="logo" v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chatFlag: false,
      cheatList: [{ name: "whole", id: 0 }],
      playerList: [],
      value: 0,
      input: "",

      msgList: [[]],
      name: "",
      auth: 0,
    };
  },

  methods: {
    chooseRoom(e) {
      this.value = e;
    },
    keyFlag(e) {
      console.log(123);
      this.Bus.$emit("keyFlag", e);
    },
    enter() {
      console.log("enter");
    },
    send() {
      if (!this.input) {
        this.$message.error(this.$t("info.lang.sendError"));
        return;
      }
      if (this.value == 0) {
        this.$chat.send(`${this.$chat.connectInfo.CMD_USER_CHATS},${this.input}`);

        console.log(this.$chat.role.auth);
        // document.o2.chat_pop(document.o2.player, this.input);
      } else {
        this.$chat.send(
          `${this.$chat.connectInfo.CMD_USER_CHAT},${this.cheatList[this.value].id},${
            this.input
          },${this.value}`
        );
      }
      this.input = "";
    },

    onlyChat(a, b, c) {
      console.log(a, b);
      if (this.$chat.role.name == b) {
        console.log("不能与自己聊天");
        return;
      }
      var found = this.cheatList.filter((el) => el.name === b).length > 0; // .length returns 1 if id exist in an array

      if (!found) {
        this.cheatList.push({
          name: a,
          id: c,
        });
      }
      var value = this.cheatList.findIndex((item) => item.name === b);
      this.value = value;
    },

    to_footer() {
      var div = document.getElementById("chat");
      setTimeout(() => {
        div.scrollTop = div.scrollHeight;
      }, 100);
    },
  },

  created() {
    var that = this;
    document.onkeydown = function (el) {
      if (el.keyCode == 13) {
        if (that.chatFlag) {
          that.send();
          that.$refs.input.blur();
        }
      } else {
      }
    };

    this.Bus.$on("msgList", (e) => {
      console.log(123);
      this.msgList = e;
      this.to_footer();
    });

    this.Bus.$on("playerList", (e) => {
      this.playerList = e;
    });

    this.Bus.$on("reciveMsg", (e) => {
      this.name = this.$chat.role.name;
      var found = this.cheatList.filter((el) => el.name === e.from).length > 0;
      if (!found) {
        this.msgList.push([]);
        this.cheatList.push({
          name: e.name,
          id: e.from,
        });
      }
      var value = this.cheatList.findIndex((item) => item.name === e.from);
      this.value = value;
      this.msgList[value].push({
        name: e.name,
        msg: e.msg,
        url: e.url,
      });
      this.$chat.msgList = this.msgList;
      this.to_footer();
    });
  },
};
</script>

<style lang="scss" scoped>
.sendLine {
  position: fixed;
  right: 44px;
  bottom: 30px;
  display: flex;
  justify-content: space-between;
  width: 330px;
  z-index: 2;
  .send {
    width: 63px;
    height: 38px;
    background: url("../assets/newImg/send.png");
    background-size: 100% 100%;
    font-size: 14px;
    font-family: BMW Group, BMW Group-Bold;
    color: white;
    cursor: pointer;
  }
  input {
    width: 230px;
    padding: 0 10px;
    outline: none;
    border: 0;
  }
  .middle {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.msgBox {
  width: 355px;
  height: 200px;
  position: fixed;
  bottom: 82px;
  right: 0;
  background: url("../assets/newImg/sendBox.png");
  background-size: 100% 100%;
  padding: 0 10px;
  transition: 0.5s;
  // mix-blend-mode: screen;
  .title {
    display: flex;
    border-bottom: 1px solid white;
    height: 30px;
    align-items: center;
    position: relative;
    p {
      height: 15px;
      font-size: 12px;
      font-family: BMW Group, BMW Group-Regular;
      font-weight: bold;
      color: #3f4957;
      padding: 0 10px;
      border-right: 1px solid white;
      cursor: pointer;
      width: 50px;
    }
  }
  .box {
    margin-top: 10px;
    height: 150px;
    display: flex;
    transition: 0.5s;
    .box1 {
      width: 200px;
      border-right: 1px solid #fff;
      overflow-y: scroll;
      .msgList {
        display: flex;
        flex-wrap: wrap;
        font-size: 12px;
        margin-bottom: 8px;
        color: #3f4957;
        .name {
          margin: 0 10px;
          width: 50px;
          text-align: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .sendMsg {
          flex: 1;
          text-align: left;
          margin-right: 10px;
          word-wrap: break-word;
          width: 180px;
          word-break: break-all;
        }
      }
    }
    .box2 {
      overflow-y: scroll;
      flex: 1;
    }
  }

  .msg1 {
    display: flex;
    width: 145px;
    height: 28px;
    border-radius: 2px;
    margin-bottom: 6px;
    margin-left: 5px;
    align-items: center;
    p {
      font-size: 13px;
      color: #ffffff;
      margin-left: 5px;
      flex: 1;
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      opacity: 0.8;
      background: linear-gradient(to right, transparent, #ffffff);
      height: 100%;
      align-items: center;
      display: flex;
      color: #3f4957;
      flex-direction: row-reverse;
      padding-right: 10px;
    }
    .logo {
      margin-left: 5px;
      margin-right: 0;
      cursor: pointer;
      width: 28px;
    }
  }
}

.trans {
  width: 20px;
  position: absolute;
  right: 10px;
  transform: rotate(180deg);
  cursor: pointer;
  transition: 0.5s;
}

.trans1 {
  transform: rotate(0deg);
}

.box1::-webkit-scrollbar {
  width: 0 !important;
}
.box2::-webkit-scrollbar {
  width: 0 !important;
}
// .active {
//   color: #fff !important;
// }
</style>
